// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /squares/grid-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSquaresGridGetBody,
  typeSquaresGridGetOutput200,
} from "../../sdk/squares/postSquaresGridGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSquaresGridGetQueryKey(
  payload: typeSquaresGridGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`gridId:${JSON.stringify(payload.gridId)}`);
  if (typeof payload.eventId !== "undefined") {
    queryKeySegments.push(`eventId:${JSON.stringify(payload.eventId)}`);
  }
  return [
    "post:squares:squaresGridGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSquaresGridGetOutput200,
    unknown,
    typeSquaresGridGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSquaresGridGet(
  payload: typeSquaresGridGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSquaresGridGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSquaresGridGet(payload),
    ...resolvedOptions,
  });
}
